import { useSelector } from 'react-redux';

export function useProductList() {
  const { tenantProducts } = useSelector(({ finders }) => finders);
  return tenantProducts?.map(item => ({ label: item.name, value: item.id, image: item.imageUrl, productName: item?.name }));
}
